module.exports = __webpack_public_path__ + "img/page45.cbad8eea.gif";